'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var MONTHS = exports.MONTHS = {
    rus: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
    enu: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};

var getMonthDictionary = exports.getMonthDictionary = function getMonthDictionary(locale) {
    return MONTHS[locale].map(function (month, index) {
        return {
            value: index,
            label: month
        };
    });
};